import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'meniu',
    loadChildren: () => import('./meniu/meniu.module').then( m => m.MeniuPageModule),
    canActivate: [AuthGuard]  
  },
  {
    path: 'room',
    loadChildren: () => import('./room/room.module').then( m => m.RoomPageModule),
    canActivate: [AuthGuard]  
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then( m => m.UserPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'card',
    loadChildren: () => import('./card/card.module').then( m => m.CardPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'employee',
    loadChildren: () => import('./employee/employee.module').then( m => m.EmployeePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'locker',
    loadChildren: () => import('./locker/locker.module').then( m => m.LockerPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'door',
    loadChildren: () => import('./door/door.module').then( m => m.DoorPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'locker/:name/:id',
    loadChildren: () => import('./locker/locker.module').then( m => m.LockerPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'door/:roomname/:roomid/:lockername/:lockerid',
    loadChildren: () => import('./door/door.module').then( m => m.DoorPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-room',
    loadChildren: () => import('./add-room/add-room.module').then( m => m.AddRoomPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-personal',
    loadChildren: () => import('./add-personal/add-personal.module').then( m => m.AddPersonalPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-employee',
    loadChildren: () => import('./edit-employee/edit-employee.module').then( m => m.EditEmployeePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'modify-door-card',
    loadChildren: () => import('./modify-door-card/modify-door-card.module').then( m => m.ModifyDoorCardPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'modify-door-card/:roomname/:roomid/:lockername/:lockerid/:doorname/:doorid',
    loadChildren: () => import('./modify-door-card/modify-door-card.module').then( m => m.ModifyDoorCardPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-room',
    loadChildren: () => import('./edit-room/edit-room.module').then( m => m.EditRoomPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-room/:roomname',
    loadChildren: () => import('./edit-room/edit-room.module').then( m => m.EditRoomPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-card',
    loadChildren: () => import('./add-card/add-card.module').then( m => m.AddCardPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-card',
    loadChildren: () => import('./edit-card/edit-card.module').then( m => m.EditCardPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-locker',
    loadChildren: () => import('./add-locker/add-locker.module').then( m => m.AddLockerPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-locker/:roomname/:roomid/:rfid',
    loadChildren: () => import('./add-locker/add-locker.module').then( m => m.AddLockerPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-rfid',
    loadChildren: () => import('./add-rfid/add-rfid.module').then( m => m.AddRfidPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-rfid/:roomname/:roomid',
    loadChildren: () => import('./add-rfid/add-rfid.module').then( m => m.AddRfidPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-employee',
    loadChildren: () => import('./add-employee/add-employee.module').then( m => m.AddEmployeePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-user',
    loadChildren: () => import('./edit-user/edit-user.module').then( m => m.EditUserPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-rfid',
    loadChildren: () => import('./edit-rfid/edit-rfid.module').then( m => m.EditRfidPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-rfid/:roomname/:roomid',
    loadChildren: () => import('./edit-rfid/edit-rfid.module').then( m => m.EditRfidPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-locker/:roomname/:roomid',
    loadChildren: () => import('./edit-locker/edit-locker.module').then( m => m.EditLockerPageModule)
  },
  {
    path: 'add-user-card',
    loadChildren: () => import('./add-user-card/add-user-card.module').then( m => m.AddUserCardPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-card-user',
    loadChildren: () => import('./add-card-user/add-card-user.module').then( m => m.AddCardUserPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'language-popover',
    loadChildren: () => import('./language-popover/language-popover.module').then( m => m.LanguagePopoverPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'report',
    loadChildren: () => import('./report/report.module').then( m => m.ReportPageModule),
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
